import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RoomIcon(props: IconProps) {
    return <Icon {...props} iconKey={"room"}/>
}
